import { setReplaceText, formatPostalCode } from 'src/utils';

import { AddressDataProps, FilteredNetworkCheckProps } from '..';
import { DialogStatusProps } from '../_DialogNetwork';

import { replaceUrlParameters } from './replaceUrlParameters';
import { getAddressReplaceText } from './getAddressReplaceText';

type HandleStaticCongestionProps = {
  address?: AddressDataProps;
  networkCheck: FilteredNetworkCheckProps;
};

export const handleStaticCongestion = ({ address, networkCheck }: HandleStaticCongestionProps) => {
  const replaceTextOutage = replaceUrlParameters({
    ...address,
    postalCode: formatPostalCode(address?.postalCode ?? ''),
  });

  const replaceText = getAddressReplaceText({
    city: address?.city,
    postalCode: address?.postalCode ?? '',
    houseNumber: address?.houseNumber ?? '',
    houseNumberAddition: address?.houseNumberAddition,
  });

  const networkCongestions: DialogStatusProps = {
    title: networkCheck?.fullCongestionsTitle?.toString() ?? '',
    message: setReplaceText(networkCheck?.fullCongestionsText ?? '', {
      ...replaceTextOutage,
      ...replaceText,
    }),
  };

  return networkCongestions;
};
